import "./PercentageInputField.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PercentageInputField = ({
  placeholder = "",
  name = "",
  isRequired,
  label = null,
  isDisabled = false,
  errorMessage = undefined,
  onChange = () => {},
  value = "",
  register = () => {},
  onKeyUp = () => {},
  floatError = true,
  percentLabel = (
    <span className="d-block" style={{ height: "40px", padding: "10px" }}>
      %
    </span>
  ),
  percentBg = "#7647ee",
  percentColor = "white",
  coverClassNames = "",
  ...props
}) => {
  return (
    <span className={`percentage-input-field-container ${coverClassNames}`}>
      {label !== null && (
        <label htmlFor={name}>
          {isRequired && <span className="text-danger">*</span>}
          <span>{label}</span>
        </label>
      )}
      <span
        className={`percentage-input-field-container__input-section ${
          isDisabled === true && "disabled"
        } ${errorMessage !== undefined && "error-border"}`}
      >
        <input
          name={name}
          id={name}
          placeholder={placeholder}
          disabled={isDisabled}
          {...register(name, { required: isRequired })}
          onChange={onChange}
          onKeyUp={onKeyUp}
          value={value}
          {...props}
        />
        <span
          style={{
            background: percentBg,
            color: percentColor,
            height: "98%",
            lineHeight: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          {percentLabel}
        </span>
      </span>
      {floatError || errorMessage !== undefined ? (
        <p
          className={`error-message text-danger ${
            errorMessage !== undefined ? "show" : ""
          }`}
        >
          <FontAwesomeIcon
            icon={["fas", "exclamation-circle"]}
            className="mr-2"
            style={{ fontSize: "13px" }}
          />
          {errorMessage !== undefined && <span>{errorMessage.message}</span>}
        </p>
      ) : null}
    </span>
  );
};

export default PercentageInputField;
